import { useSearchQuery } from '@infield/features/template';
import { createContext } from 'react';

export type SearchFilterContextInterface = {
  useSearchQuery: typeof useSearchQuery;
};

const defaultValues: SearchFilterContextInterface = {
  useSearchQuery,
};

export const SearchFilterContext =
  createContext<SearchFilterContextInterface>(defaultValues);
